module.exports = __webpack_public_path__ + "img/mobleftimage.db653044.svg";